/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const WxBind = {
  path: '/wx-bind',
  name: 'wx-bind',
  component: () => import('@/views/wx-bind/index.vue'),
  children: [
    {
      path: 'user-info',
      name: 'wx-bind-user-info',
      component: () => import(/* webpackChunkName: "wx-bind" */ '@/views/wx-bind/user-info.vue'),
    },
  ],
}
export default WxBind
